// extracted by mini-css-extract-plugin
export default {"heading":"TableHeadingSort__heading___KBHAv","sortIcon":"TableHeadingSort__sortIcon___p6zKg"};